export class WorkOrderInfoReq{
    workOrderNo : string;
    voucherNumber : string;
    agent : string;
    baleNumber : string;

    constructor(workOrderNo : string,voucherNumber : string,agent : string,baleNumber : string){
        this.workOrderNo = workOrderNo
        this.voucherNumber = voucherNumber
        this.agent = agent
        this.baleNumber = baleNumber
    }
}